import axios from 'axios';

export function isNotFoundError(error: unknown): boolean {
    return axios.isAxiosError(error) && error.response?.status === 404;
}

export function isConflictError(error: unknown): boolean {
    return axios.isAxiosError(error) && error.response?.status === 409;
}

export class ExternalFetchError extends Error {
    constructor(public readonly response: Response) {
        super(`Failed to fetch: ${response.status}`);
    }
}

export async function fetchExternalBlob(url: string): Promise<Blob> {
    const response = await fetch(url, { credentials: 'include' });
    if (!response.ok) {
        throw new ExternalFetchError(response);
    }
    return response.blob();
}

export function isCanceledError(error: unknown): boolean {
    return axios.isCancel(error);
}

export async function readErrorBlobText(error: unknown): Promise<string> {
    if (!axios.isAxiosError(error)) return '';
    const data = error.response?.data;
    if (data instanceof Blob) return data.text().catch(() => '');
    return '';
}
